import React, { PureComponent } from "react";
import classes from "./Partners.module.css";
import cn from "clsx";
import { OutboundLink } from "gatsby-plugin-google-analytics";

interface PartnersProps {}

class Partners extends PureComponent<PartnersProps> {
  render(): React.ReactNode {
    return (
      <div className={cn(classes.logos)}>
        <a href="https://www.mos.ru/dt/">
          <img
            className={cn(classes.logoDeptrans)}
            src={require("./assets/deptrans.svg")}
            height="46px"
            alt="Логотип Департамента Транспорта Москвы"
          />
        </a>
        <div className={cn(classes.logosInner)}>
          <a href="https://maximatelecom.ru/">
            <img
              src={require("./assets/maxima.png")}
              height="40px"
              alt="Логотип Maxima Telecom"
            />
          </a>
          <a href="https://qvant.ru">
            <img
              src={require("./assets/quant.svg")}
              height="35px"
              alt="Логотип Quant"
            />
          </a>
          <OutboundLink href="https://fundvet.city">
            <img
              src={require("./assets/adoption-fundvetcity.svg")}
              height="49px"
              alt="Логотип Adoption FundVetCity"
            />
          </OutboundLink>
        </div>
      </div>
    );
  }
}

export default Partners;
